import { useNavigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import {
  Grid,
  Paper,
  Avatar,
  Typography,
  Button,
  CssBaseline,
  Box,

} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/Lock";

const defaultTheme = createTheme();

export default function AlterarSenhaEnviado() {

  const navigate = useNavigate();
  const logosys = new URL("../../assets/Logosys.png", import.meta.url).href;

  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />


        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${logosys})`,
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "left",
          }}
        />

        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            px: { xs: 3, sm: 6 },
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "#00597A" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Lembrar Senha
          </Typography>

          <Box
            component="form"
            noValidate
            sx={{ mt: 1, width: "100%" }}
          >
            <Box sx={{ mt: 2, mb: 5 }}>
              <Typography sx={{ textAlign: "center" }}>
                E-mail com procedimentos enviado com sucesso! <br />
                Caso não o receba, verifique sua caixa de SPAM!{" "}
              </Typography>
            </Box>

            <Grid
              xs={12}
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 2,
              }}
            >
              {/* Botões lado a lado */}
              <Box sx={{ display: "flex", width: "48%" }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={{ position: "relative", backgroundColor: "#00597A" }}
                  onClick={() => navigate("/login")}
                >
                  ok
                </Button>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
